import React, { useState, useEffect } from 'react';
import './footer.css';
import { Link } from 'react-router-dom';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faYoutube,
  faLinkedinIn,
  faTwitter,
  faPinterestP,
  faHouzz,
} from '@fortawesome/free-brands-svg-icons';
import { faChevronDown as faDown, faChevronUp as faUp } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showWhyMarvel, setShowWhyMarvel] = useState(false);
  const [showResources, setShowResources] = useState(false);
  const [showContact, setShowContact] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <a target="_blank" href="https://api.whatsapp.com/send/?phone=919574313456&text=Hi&type=phone_number&app_absent=0" className="WP-chat-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#fff" d="M3.516 3.516c4.686-4.686 12.284-4.686 16.97 0s4.686 12.283 0 16.97a12 12 0 0 1-13.754 2.299l-5.814.735a.392.392 0 0 1-.438-.44l.748-5.788A12 12 0 0 1 3.517 3.517zm3.61 17.043.3.158a9.85 9.85 0 0 0 11.534-1.758c3.843-3.843 3.843-10.074 0-13.918s-10.075-3.843-13.918 0a9.85 9.85 0 0 0-1.747 11.554l.16.303-.51 3.942a.196.196 0 0 0 .219.22zm6.534-7.003-.933 1.164a9.84 9.84 0 0 1-3.497-3.495l1.166-.933a.79.79 0 0 0 .23-.94L9.561 6.96a.79.79 0 0 0-.924-.445l-2.023.524a.797.797 0 0 0-.588.88 11.754 11.754 0 0 0 10.005 10.005.797.797 0 0 0 .88-.587l.525-2.023a.79.79 0 0 0-.445-.923L14.6 13.327a.79.79 0 0 0-.94.23z" /></svg>
      </a>


      <footer className="footer">
        <div className="footer-container">
          {isMobile ? (
            <>
              <div className="footer-dropdown footer-dropdown-id1">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowWhyMarvel(!showWhyMarvel)}
                >
                  WHY CALLISTUS?
                  <FontAwesomeIcon icon={showWhyMarvel ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showWhyMarvel ? 'show' : ''}`}>
                  <ul>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/light-control-privacy">Light Control & Privacy</Link>
                    </li>
                    <li>
                      <Link to="/innovation">Innovation</Link>
                    </li>
                    <li>
                      <Link to="/energy-efficiency">Energy Efficiency</Link>
                    </li>
                  </ul>

                  <h3 className="SubCol">Updates</h3>
                  <ul>
                    <li>
                      <Link to="/news">News</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-dropdown footer-dropdown-id2">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowResources(!showResources)}
                >
                  RESOURCES
                  <FontAwesomeIcon icon={showResources ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showResources ? 'show' : ''}`}>
                  <ul>
                    <li>
                      <Link to="/frequently-asked-questions">FAQs</Link>
                    </li>
                    <li>
                      <Link to="/special-solutions">Special Solutions</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-conditions">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="/operating-systems">Operating Systems</Link>
                    </li>
                    <li>
                      <Link to="/fabric-shade">Fabric Shade</Link>
                    </li>
                    <li>Dealer Login</li>
                  </ul>
                </div>
              </div>

              <div className="footer-dropdown footer-dropdown-id3">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowContact(!showContact)}
                >
                  CONTACT US
                  <FontAwesomeIcon icon={showContact ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showContact ? 'show' : ''}`}>
                  <p><strong>UK:</strong><a href="tel:+441133206427"> +44 113 32 06427</a></p>
                  <p><strong>USA:</strong><a href="tel:+16464665719"> +1-646-466-5719</a></p>
                  <p><strong>UAE:</strong><a href="tel:+16464665719"> +971 58 645 2901</a></p>
                  <p><strong>Email:</strong><a href="mailto:sales@callistusblinds.com"> sales@callistusblinds.com</a></p>
                  <ul>
                    <li>
                      <Link to="/Trade">Trade Inquires</Link>
                    </li>
                    <li> <Link to="/contact">Connect to Our Consultant </Link></li>
                  </ul>
                </div>
              </div>

              <div className="connect-section">
                <h3>CONNECT</h3>
                <div className="social-icons">
                  <a href="https://www.facebook.com/callistuswindowfashion"><FontAwesomeIcon icon={faFacebookF} /></a>
                  <a href="https://www.instagram.com/callistus_blinds/"><FontAwesomeIcon icon={faInstagram} /></a>
                  <a href="https://www.youtube.com/channel/UCIGZv-7grR12pSrQzDu0qbw"><FontAwesomeIcon icon={faYoutube} /></a>
                  <a href="https://twitter.com/ukcallistus"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a href="https://www.houzz.in/pro/webuser-709495382/callistus-window-fashion-uk"><FontAwesomeIcon icon={faHouzz} /></a>
                  <a href="https://www.linkedin.com/company/callistus-window-fashion-uk/"><FontAwesomeIcon icon={faPinterestP} /></a>
                  <a href="https://www.linkedin.com/company/callistus-window-fashion-uk/"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="footer-column">
                <h3>WHY CALLISTUS?</h3>
                <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/light-control-privacy">Light Control & Privacy</Link>
                  </li>
                  <li>
                    <Link to="/innovation">Innovation</Link>
                  </li>
                  <li>
                    <Link to="/energy-efficiency">Energy Efficiency</Link>
                  </li>
                </ul>

                <h3 className="SubCol">Updates</h3>
                <ul>
                  <li>
                    <Link to="/news">News</Link>
                  </li>
                  <li>
                    <Link to="/blogs">Blogs</Link>
                  </li>
                </ul>

              </div>

              <div className="footer-column">
                <h3>RESOURCES</h3>
                <ul>
                  <li>
                    <Link to="/frequently-asked-questions">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/special-solutions">Special Solutions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-conditions">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/operating-systems">Operating Systems</Link>
                  </li>
                  <li>
                    <Link to="/fabric-shade">Fabric Shade</Link>
                  </li>
                  <li>Dealer Login</li>
                </ul>
              </div>
              <div className="footer-column">
                <h3>CONTACT US</h3>
                <p><strong>UK:</strong><a href="tel:+441133206427"> +44 113 32 06427</a></p>
                <p><strong>USA:</strong><a href="tel:+16464665719"> +1-646-466-5719</a></p>
                <p><strong>UAE:</strong><a href="tel:+16464665719"> +971 58 645 2901</a></p>
                <p><strong>Email:</strong><a href="mailto:sales@callistusblinds.com"> sales@callistusblinds.com</a></p>
                <ul>
                  <li>
                    <Link to="/Trade">Trade Inquires</Link>
                  </li>
                  <li> <Link to="/contact">Connect to Our Consultant </Link></li>
                </ul>
                <h3 className="connect-sec">CONNECT</h3>
                <div className="social-icons">
                  <a href="https://www.facebook.com/callistuswindowfashion"><FontAwesomeIcon icon={faFacebookF} /></a>
                  <a href="https://www.instagram.com/callistus_blinds/"><FontAwesomeIcon icon={faInstagram} /></a>
                  <a href="https://www.youtube.com/channel/UCIGZv-7grR12pSrQzDu0qbw"><FontAwesomeIcon icon={faYoutube} /></a>
                  <a href="https://twitter.com/ukcallistus"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a href="https://www.houzz.in/pro/webuser-709495382/callistus-window-fashion-uk"><FontAwesomeIcon icon={faHouzz} /></a>
                  <a href="https://www.linkedin.com/company/callistus-window-fashion-uk/"><FontAwesomeIcon icon={faPinterestP} /></a>
                  <a href="https://www.linkedin.com/company/callistus-window-fashion-uk/"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                </div>
              </div>
            </>
          )}

          <div className="footer-column footer-col4">
            <h3>SIGN UP FOR UPDATES, TIPS AND OFFERS</h3>
            <p>Get inspired with design information and promotions.</p>
            <form>
              <input type="email" placeholder="Enter Your Email" />
              <button type='submit'>Submit</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom footer-bottom-sec">
          <Link to="/"><img src="https://callistusblinds.ae/wp-content/themes/MyCallistus/images/logo.svg" alt="Marvel Logo" className="footer-logo" /></Link>
          <p>© 2025 Callistus Blinds. All Rights Reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;